<template>
  <div class="con">
    <Header></Header>
    <div class="empty">
      <div class="picture">
        <img :src="bg" alt />
        <div class="tips">
          <div class="title">{{ $t('empty.tips') }}</div>
          <p>{{ $t('empty.info') }}</p>
        </div>
      </div>

      <div class="option">
        <h3>{{ $t('empty.option') }}</h3>
        <p><span>1</span>{{ $t('empty.option.p1') }}</p>
        <p><span>2</span>{{ $t('empty.option.p2') }}</p>
        <p><span>3</span>{{ $t('empty.option.p3') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header.vue';
import bg from '@/assets/img/bg.png';
export default {
  components: { Header },
  data() {
    return {
      bg,
    };
  },
};
</script>

<style lang="less" scoped>
.empty {
  img {
    width: 100%;
    height: 100%;
  }
  p {
    color: #515b73;
    font-size: 28px;
    line-height: 42px;
  }
  .picture {
    width: 100%;
    height: 100%;
    position: relative;

    .tips {
      position: absolute;
      top: 0;
      left: 0;
      padding: 60px 40px;
      text-align: left;

      .title {
        font-size: 32px;
        color: #00ccbf;
        font-weight: bold;
        margin-bottom: 20px;
      }
    }
  }

  .option {
    text-align: left;
    padding: 60px 40px;
    h3 {
      font-size: 32px;
      color: #363d4d;
      letter-spacing: 0;
      line-height: 42px;
    }

    p {
      display: flex;
      margin-top: 30px;
      span {
        display: inline-block;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #00ccbf;
        margin-right: 20px;
      }
    }
  }
}
</style>
